import React from 'react';
import { parseChoiceLines, parseGapLines } from '../lib/questionText';
import { button, hint, label as labelStyle, primaryButton } from '../../../shared/ui/formStyles';

// Необязательный быстрый путь: вставить сразу много готовых речень из файла.
// Основной способ — карточки, поэтому окно открывается по кнопке и объясняет
// формат на примере.
const BulkPasteModal = ({ isOpen, isTextQuestion, questionId, existingCount, onCancel, onConfirm }) => {
  const [text, setText] = React.useState('');

  React.useEffect(() => {
    if (isOpen) setText('');
  }, [isOpen]);

  if (!isOpen) return null;

  const parsed = isTextQuestion
    ? parseGapLines(text, { questionId })
    : parseChoiceLines(text, { questionId });

  const groups = parsed.groups.map((group, index) => {
    const id = `${questionId}-g${existingCount + index + 1}`;

    return {
      ...group,
      id,
      options: group.options?.map((option, optionIndex) => ({
        ...option,
        id: `${id}-o${optionIndex + 1}`,
      })),
    };
  });

  const example = isTextQuestion
    ? 'James lives ___ Cambridge. = in\nHe lives ___ two other boys. = with'
    : 'I ___ Anna ten years ago. = *met | have met\nWhich are irregular verbs? = *go | *write | want | listen';

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px',
          width: '100%',
          maxWidth: '720px',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <h3 style={{ margin: '0 0 6px', fontSize: '18px', color: '#0F172A' }}>
          Додати багато речень одразу
        </h3>
        <p style={{ ...hint, marginTop: 0 }}>
          Зручно, коли завдання вже набране у Word. Одне речення — один рядок, після знака «=»
          правильна відповідь.
          {isTextQuestion
            ? ' Якщо відповідей кілька, розділіть їх рискою «|».'
            : ' Варіанти розділяються рискою «|», а правильні позначаються зірочкою «*» — зірочок може бути кілька.'}
        </p>

        <div
          style={{
            background: '#F8FAFC',
            border: '1px solid #E2E8F0',
            borderRadius: '8px',
            padding: '10px 12px',
            fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
            fontSize: '13px',
            color: '#475569',
            whiteSpace: 'pre-wrap',
            margin: '10px 0 14px',
          }}
        >
          {example}
        </div>

        <span style={labelStyle}>Вставте текст сюди</span>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={10}
          spellCheck={false}
          style={{
            width: '100%',
            padding: '12px',
            border: '1px solid #CBD5E1',
            borderRadius: '8px',
            fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
            fontSize: '14px',
            lineHeight: 1.7,
          }}
        />

        <p style={hint}>
          Буде додано речень: <strong>{groups.length}</strong>
          {parsed.issues.length > 0 && (
            <span style={{ color: '#B45309' }}>
              {' '}· потребують уваги: {parsed.issues.length} (рядки{' '}
              {parsed.issues.slice(0, 5).map((issue) => issue.line).join(', ')}
              {parsed.issues.length > 5 ? '…' : ''}). Їх теж можна додати й дозаповнити в картках.
            </span>
          )}
        </p>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '18px' }}>
          <button type="button" onClick={onCancel} style={button}>
            Скасувати
          </button>
          <button
            type="button"
            disabled={groups.length === 0}
            onClick={() => onConfirm(groups)}
            style={{
              ...primaryButton,
              opacity: groups.length === 0 ? 0.5 : 1,
              cursor: groups.length === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            Додати {groups.length || ''}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkPasteModal;
